export default {
  listMailFolder: state => state.listMailFolder,
  selectedMailFolder: state => state.selectedMailFolder,
}